import { render } from "./SideMenu.vue?vue&type=template&id=2e265126&scoped=true"
import script from "./SideMenu.vue?vue&type=script&lang=js"
export * from "./SideMenu.vue?vue&type=script&lang=js"

import "@/assets/css/user/common.css?vue&type=style&index=0&id=2e265126&scoped=true&lang=css"
import "@/assets/css/user/pages/menu.css?vue&type=style&index=1&id=2e265126&scoped=true&lang=css"
import "@/assets/css/user/pages/touchbox.css?vue&type=style&index=2&id=2e265126&scoped=true&lang=css"
import "@/assets/css/user/dark/common-dark.css?vue&type=style&index=3&id=2e265126&scoped=true&lang=css"
import "@/assets/css/user/dark/menu-dark.css?vue&type=style&index=4&id=2e265126&scoped=true&lang=css"
import "@/assets/css/user/dark/touchbox-dark.css?vue&type=style&index=5&id=2e265126&scoped=true&lang=css"
import "./SideMenu.vue?vue&type=style&index=6&id=2e265126&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shcho\\Desktop\\home\\git\\test\\cloudpos.kiosk\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e265126"]])

export default __exports__